module.exports = __webpack_public_path__ + "img/数字成就美好生活图片.e6d70478.png";